import { Component, inject, type OnInit } from '@angular/core'
import { DateAdapter } from '@angular/material/core'
import { Title } from '@angular/platform-browser'
import { CITY_PROFILE } from '@core/city-profile/city-profile.util'
import { DictionaryService } from '@core/locale/dictionary.service'
import { LocaleService } from '@core/locale/locale.service'
import { filter, switchMap } from 'rxjs'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  DictionaryService = inject(DictionaryService)
  LocaleService = inject(LocaleService)
  DateAdapter = inject(DateAdapter)
  Title = inject(Title)

  currentLocale = ''

  async ngOnInit (): Promise<void> {
    // set the browser tab title from the active city profile
    this.Title.setTitle(CITY_PROFILE.displayName)

    if ('fonts' in document) {
      await document.fonts.ready
      document.body.classList.add('fonts_loaded')
    }

    const locale = this.LocaleService.getLocale()
    this.DateAdapter.setLocale(locale)

    this.LocaleService.localeBS.pipe(
      filter(_locale => _locale !== this.currentLocale),
      switchMap(async _locale => {
        this.currentLocale = _locale
        await this.DictionaryService.refresh(_locale)
      })
    ).subscribe()
  }
}
